module.exports = __webpack_public_path__ + "img/morgan.08f6c8b0.png";